import { useContext, useState } from "react";
import { assets } from "../../assets/assets";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { IoHomeOutline } from "react-icons/io5";
import { IoGiftOutline } from "react-icons/io5";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { ShopContext } from "../../context/ShopContext";
import { BsArrowRight } from "react-icons/bs";
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axiosInstance';
import { AuthContext } from '../../context/AuthContext';
import { useSelector } from 'react-redux';
import { selectTotalUniqueItems } from '../../store/cartSlice';

const Navbar = () => {

  const totalItems = useSelector(selectTotalUniqueItems);
  const [visible, setVisible] = useState(false);

  const { isLoggedIn, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axiosInstance.post('/logout');
      logout();
      toast.success('Logged out successfully.');
      navigate('/otp-login');
    } catch (error) {
      logout();
      toast.error('Logout failed. You were logged out locally.');
      navigate('/otp-login');
    }
  };

  return (
    <div className="header-section">
      <div className="container">
        <header>
          <div className="logo-section">
            <Link to='/'>
              <img src={assets.logo} alt="" />
            </Link>
          </div>

          <div className="menu-section for-web">
            <div className="menu-item">
              <NavLink to="/">Home</NavLink>
              <NavLink to="/explore-campaign">Explore Campaign</NavLink>
              <NavLink to="/donate-monthly">Donate Monthly</NavLink>
              <NavLink to="/about">About</NavLink>
            </div>
            <div className="dropdown-menu-item">
              <div className="dropdown">
                <button
                  className=" btn_donate rounded-4 dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Donate
                  <i className="fa fa-angle-down"></i>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      className="dropdown-item"
                      href="donate-monthly.html"
                      to="/donate-monthly"
                    >
                      Donate Monthly
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      href="explore-campaign.html"
                      to="/explore-campaign"
                    >
                      Explore Campaingns
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="header-other">
            <div className="dropdown menu-section for-web">
              <button
                className="rounded-4 dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={assets.flag}
                  className="img-fluid rounded-pill"
                  alt="India"
                />
                <span>₹ (INR)</span>
                <i className="fa fa-angle-down"></i>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to=''>
                    ₹ (INR)
                  </Link>
                </li>
              </ul>
            </div>
            <div className="user-icon-header demon-img">
              <ul>
                <li>
                  <img src={assets.user} alt="user icon" />
                  <ul>
                    {isLoggedIn ? (
                      <>
                        <li><Link to="/account">Account</Link></li>
                        <li><button onClick={handleLogout} className="btn btn-link p-0 m-0 text-start">Logout</button></li>
                      </>
                    ) : (
                      <li><Link to="/otp-login">Login</Link></li>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
            <Link to='/cart' className="cart-icon-header demon-img">
              <img src={assets.cart} alt="" />
              <div className="number-products">{totalItems}</div>
            </Link>
          </div>

        </header>
        <div className="mobile-menu for-mobile">

          <div className="menu-items-mobile">
            <NavLink to="/"><div className="menu-left-icon"><IoHomeOutline /></div><span>Home</span></NavLink>
            <NavLink to="/explore-campaign"><div className="menu-left-icon"><IoGiftOutline /></div><span>Campaigns</span></NavLink>
            <NavLink to="/donate-monthly"><div className="menu-left-icon"><MdOutlineCalendarMonth /></div><span>Monthly</span></NavLink>
            <NavLink ><div className="menu-left-icon"><img onClick={() => setVisible(true)} src={assets.menu_icon} alt="" /></div><span>Menu</span></NavLink>
          </div>



        </div>
        <div className={`hamburger-menu for-mobile ${visible ? 'width-100' : 'width-0'}`}>
          <div className="hamburger-wrapper">
            <div onClick={() => setVisible(false)} className="close-hamburger">

              <img src={assets.dropdown_icon} alt="" /><span>Back</span>
            </div>
            <div className="dropdown menu-section ">
              <button
                className="rounded-4 dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={assets.flag}
                  className="img-fluid rounded-pill"
                  alt="India"
                />
                <span>₹ (INR)</span>
                <i className="fa fa-angle-down"></i>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to=''>
                    ₹ (INR)
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="login-button-common">
            <Link onClick={() => setVisible(false)} to="/login">Login / Register</Link>
          </div>
          <div className="login-button">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              <img src={assets.youtube_icon} className="img-fluid" alt="Watch" /> How to donate
            </button>

            {/* Modal */}
            <div className="modal fade"
              id="exampleModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">

                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="modal-body p-0">
                      <div className="ratio ratio-16x9">
                        <iframe
                          className="w-100 rounded-4"
                          src="https://www.youtube.com/embed/hAP2QF--2Dg?si=sF8xL9HMWj1MuIgg"
                          title="YouTube video player"
                          frameBorder="0"
                          allow=" web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>


            <div className="my_account_sec pb-5 pt-3">
              <div className="">
                <div className="row gy-4 mb-4 d-flex align-items-center">
                  <div className="col-xl-6">
                    <div className="row gx-2 gy-4 gy-xl-0">
                      {/* <!-- My Donation --> */}
                      <div className="col-xl-6">
                        <div className="subs_box h-100 card border-0">
                          <div className="text-center">
                            <div className="logo mb-3">
                              <img src={assets.logo} className="img-fluid" alt="logo" />
                            </div>

                            <div className="mb-3">
                              <p>Manage subscriptions</p>
                            </div>
                            <h6 className="mb-0">Your Total Subscriptions

                            </h6>
                          </div>
                        </div>
                      </div>

                      <div className="col-4 col-md-4">
                        <Link to='/my-donate'>
                          <div className="custom-box card h-100 border-0">

                            <div className="icon">

                              <img className="img-fluid" src={assets.account_donate_icon}
                                alt="My Donation" />

                            </div>
                            <p className="mt-auto">My Donation</p>

                          </div>
                        </Link>
                      </div>

                      {/* <!-- Download Certificates --> */}
                      <div className="col-4 col-md-4">
                        <div className="custom-box card h-100 border-0">
                          <div className="icon">
                            <Link to='' className="stretched-link">
                              <img src={assets.account_certificate_icon} alt="Download Certificates" />
                            </Link>
                          </div>
                          <p className="mt-auto">Download Certificates</p>
                        </div>
                      </div>
                      {/* <!-- Support --> */}
                      <div className="col-4 col-md-4">
                        <Link to='/support-call'>
                          <div className="custom-box card h-100 border-0">
                            <div className="icon">

                              <img src={assets.account_support_icon} alt="Support" />

                            </div>
                            <p className="mt-auto">Support</p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="row mt-2 mb-2">
                  <div className="col-xl-6">
                    <Link to='/profile'>
                      <div
                        className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">

                          <div className="d-flex align-items-center">
                            <div className="me-2 icon">

                              <img src={assets.account_profile_icon} className="img-fluid" alt="profile" />

                            </div>
                            <div>
                              <h5>My Profile</h5>
                            </div>
                          </div>

                        </div>
                        <div className="item-2">
                          <div className="arrow-right">
                            <BsArrowRight />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-6">
                    <Link to='/volunteer'>
                      <div
                        className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                          <div className="d-flex align-items-center">
                            <div className="me-2 icon">

                              <img src={assets.account_volunteer_icon} className="img-fluid" alt="volunteer" />

                            </div>
                            <div>
                              <h5>Volunteer</h5>
                            </div>
                          </div>
                        </div>
                        <div className="item-2">
                          <div className="arrow-right">
                            <BsArrowRight />
                          </div>
                        </div>

                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-6">
                    <div
                      className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                      <div className="item-1">
                        <div className="d-flex align-items-center">
                          <div className="me-2 icon">
                            <Link to='' className="stretched-link">
                              <img src={assets.account_faq_icon} className="img-fluid" alt="account" />
                            </Link>
                          </div>
                          <div>
                            <h5>FAQ</h5>
                          </div>
                        </div>
                      </div>
                      <div className="item-2">
                        <div className="arrow-right">
                          <BsArrowRight />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <Link to='/refer-donate'>
                      <div
                        className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                          <div className="d-flex align-items-center">
                            <div className="me-2 icon">

                              <img src={assets.account_share_icon} className="img-fluid" alt="account" />

                            </div>
                            <div>
                              <h5>Refer – Spread the Word</h5>
                            </div>
                          </div>
                        </div>
                        <div className="item-2">
                          <div className="arrow-right">
                            <BsArrowRight />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="menu-item-hamburger">
              <NavLink onClick={()=>setVisible(false)} to="/">Home</NavLink>
              <NavLink onClick={()=>setVisible(false)} to="/explore-campaign">Explore Campaign</NavLink>
              <NavLink onClick={()=>setVisible(false)} to="/donate-monthly">Donate Monthly</NavLink>
              <NavLink onClick={()=>setVisible(false)} to="/about">About</NavLink>
            </div> */}

        </div>
      </div>
    </div>
  );
};

export default Navbar;
